module.exports = __webpack_public_path__ + "static/media/for-students-forth@3x.e85451a7.jpg";